<template>
  <div id="container">
    <div class="title_wrap">
      <div class="title_wrap">
        <h1>메뉴상세</h1>
      </div>
    </div>

    <!-- 기본정보 -->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>마스터 정보
        </h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>솔루션/웹/모바일구분 </label>
            <ul>
              <li>{{menuInfo.cvtSolCd}}{{menuInfo.cvtWmGbn}}</li>
            </ul>
          </dd>
          <dd>
            <label>메뉴계층</label>
            <ul>
              <li>{{menuInfo.menuDepth}}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>상위메뉴명</label>
            <ul>
              <li>{{menuInfo.cvtSuperMenuId}}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>상위메뉴ID</label>
            <ul>
              <li>{{menuInfo.superMenuId}}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>메뉴명</label>
            <ul>
              <li>{{menuInfo.menuNm}}</li>
            </ul>
          </dd>
          <dd>
            <label>메뉴ID</label>
            <ul>
              <li>{{menuInfo.menuId}}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>메뉴 URL</label>
            <ul>
              <li>{{menuInfo.urlLink}} </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>조회순서</label>
            <ul>
              <li>{{menuInfo.seqNo}}</li>
            </ul>
          </dd>
          <dd>
            <label>사용여부</label>
            <ul>
              <li>{{menuInfo.useYn}}</li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>


    <!---추가정보 --->
    <div class="contents_wrap">
      <div class="small_title_wrap">
        <h2>다국어정보</h2>
      </div>
      <ul class="filter_list">
        <li>
          <dd>
            <label>영어</label>
            <ul>
              <li>{{menuInfo.menuEn}}</li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>중국어</label>
            <ul>
              <li>{{menuInfo.menuZh}}</li>
            </ul>
          </dd>

        </li>
        <li>
          <dd>
            <label>베트남어</label>
            <ul>
              <li>{{menuInfo.menuVn}}</li>
            </ul>
          </dd>

        </li>
        <li>
          <dd>
            <label>일본어</label>
            <ul>
              <li>{{menuInfo.menuJp}}</li>
            </ul>
          </dd>

        </li>
      </ul>
    </div>

    <!--- 버튼영역 --->
    <div class="button_area w40">
      <ul>
        <li class="w30">
          <button class="large_btn orange" @click="onClickMenuSave"> 수정</button>
        </li>
        <li class="w30">
          <button class="large_btn" @click="onClickGoBack">목록</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import EtnersCommonUtil from '@/common/etners.common.util'
  import EtnersKendoGridUtil from '@/common/kendo.grid.util'
  import EtnersParseUtil from '@/common/etners.parse.util'
  import EtnersDateTimeUtil from '@/common/etners.datetime.util'

  export default {
    name   : 'AdminMenuDetail',
    data   : function () {
      const vm = this
      const menuId = vm.$route.params.menuId
      const solCd = vm.$route.params.solCd
      const wbGbn = vm.$route.params.wmGbn
      return {
        solCd       : solCd,
        wmGbn       : wbGbn,
        menuId      : menuId,
        menuInfo: {},
        uploads     : [],
      }
    },
    created () {

    },
    mounted: function () {
      const vm = this
      const loginUserToken = sessionStorage.lutk
      const menuId = vm.$route.params.menuId
      const solCd = vm.$route.params.solCd
      const wbGbn = vm.$route.params.wmGbn


      const solutionCodeMap = EtnersCommonUtil.getAllSolutionMasterMapUsingVuex()
      const codeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()


      let menuAllDataMap = EtnersCommonUtil.getAllMenuMasterMapUsingVuex()

      let param = {
        loginUserToken: loginUserToken,
        solCd         : solCd,
        wmGbn         : wbGbn,
        menuId         : menuId,
      }

      ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/menu/detail.json`, param).then(function (response) {
          if (response.data.resultStatus.messageCode === '2000') {
            let changeResultData = response.data.resultData

            vm.menuInfo = changeResultData

            if (vm.menuInfo != null) {

              // 코드로 코드명 조회 (솔루션, 구분, 상위메뉴명)
              vm.menuInfo.cvtSolCd = EtnersParseUtil.solutionToText(solutionCodeMap,  vm.menuInfo.solCd,  vm.menuInfo.wmGbn)
              vm.menuInfo.cvtWmgbn = EtnersParseUtil.commonCodeToText(codeMap,`102_${vm.menuInfo.wbGbn}`)
              vm.menuInfo.cvtSuperMenuId = EtnersParseUtil.superMenuIdToText(menuAllDataMap,vm.menuInfo.superMenuId ,vm.menuInfo.solCd,  vm.menuInfo.wmGbn)


            }

          } else {
            kendo.alert(response.data.resultStatus.messageText)
          }
        },
      )
    },
    methods: {
      // 메뉴 수정 버튼 클릭
      onClickMenuSave: function () {
        this.$router.push({ name: 'AdminMenuUpsert', params: { solCd: this.solCd, wmGbn: this.wmGbn  ,menuId: this.menuId} })
      },
      // 목록 버튼 클릭
      onClickGoBack      : function () {
        this.$router.go(-1)
      },
    },
  }
</script>

<style scoped>
</style>

